/** Number of resources requested per page. Kept constant so server-side paging offsets never drift between pages. */
export const PLANNER_PAGE_SIZE = 20;

/** Height of an allocation bar and the vertical gap between stacked bars, in px. */
export const ALLOCATION_BAR_HEIGHT = 20;
export const ALLOCATION_BAR_GAP = 5;

/** Vertical distance between the tops of two stacked bars. */
export const LANE_PITCH = ALLOCATION_BAR_HEIGHT + ALLOCATION_BAR_GAP;

/** Padding added above and below a stack of bars inside a row, in px. */
export const LANE_STACK_PADDING = 8;

/**
 * How many stacked bars a resource, project, scope or task group row shows. Every such row is exactly as tall as
 * this many lanes, whatever it holds: bars beyond them are not drawn, and the tasks of a row in the period are
 * counted and listed from the pill on its left.
 */
export const VISIBLE_LANES = 2;

/** Height of a resource, project, scope or task group row, and of a task row, in px. */
export const NODE_ROW_HEIGHT = VISIBLE_LANES * LANE_PITCH + LANE_STACK_PADDING;
export const TASK_ROW_HEIGHT = 40;

/** Distance from the top of a row to the first lane of bars, in px. */
export const BAR_TOP_OFFSET = 9;

/** Height of the sticky header of the left panel and of the timeline, in px. */
export const HEADER_HEIGHT = 68;

/** Rows are rendered this far (in px) beyond the visible area so scrolling never reveals an empty row. */
export const ROW_OVERSCAN_PX = 400;

/** Rows from the end of the list at which the next page of resources is requested. */
export const NEXT_PAGE_ROWS = 4;

export const LEFT_PANEL_MIN_WIDTH = 240;
export const LEFT_PANEL_MAX_WIDTH = 600;
export const LEFT_PANEL_DEFAULT_WIDTH = 310;
export const LEFT_PANEL_COOKIE_KEY = "resourcePlannerLeftPanelWidth";

/** Height of the placeholder rows shown below the list while the next page of resources is loading. */
export const LOADING_MORE_HEIGHT = 80;
